export interface PepRca {
  isPepRca: string;
  pepRcaRoleAndCountry: PepRcaRoleAndCountry[];
}

export interface PepRcaRoleAndCountry {
  role: string;
  country: string;
}

export function createEmptyPepRcaRoleAndCountry(): PepRcaRoleAndCountry {
  return { role: "", country: "" };
}
